<ng-content></ng-content>
<span *ngIf="displayTimezone" class="datetime-offset">{{ date | timezone: dateTimeFormat.DATETIME_OFFSET }}</span>
